import { type CountryType } from "@/src/lib/universities";
import { useTranslations, useLocale } from "next-intl";

type CountriesTabsProps = {
  countries: CountryType[];
  activeId: string | number;
  handleClick: (id: number) => void;
};

const CountriesTabs = ({
  countries,
  activeId,
  handleClick,
}: CountriesTabsProps) => {
  const t = useTranslations("Universities");
  const locale = useLocale();
  const isArabic = locale === "ar";

  if (countries.length <= 1) return null;

  return (
    <div className="w-full overflow-x-scroll no-scrollbar mb-6 md:mb-10">
      <div className="flex items-center gap-3 md:gap-6 w-max px-1">
        <button
          onClick={() => handleClick(0)}
          className={`small-text py-1 px-4 rounded-lg cursor-pointer transition-colors duration-300 text-white whitespace-nowrap ${
            activeId === 0 ? "bg-accent" : "bg-primary hover:bg-primary/90"
          }`}
        >
          {t("allCountries")}
        </button>
        {countries.map((country) => {
          const isActive = activeId === country.id;
          return (
            <button
              key={country.id}
              onClick={() => handleClick(country.id)}
              className={`small-text py-1 px-4 rounded-lg cursor-pointer transition-colors duration-300 text-white whitespace-nowrap ${
                isActive ? "bg-accent" : "bg-primary hover:bg-primary/90"
              }`}
            >
              {isArabic ? country.nameAr : country.name}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CountriesTabs;
